import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Xamarin = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M10.667 5.333H9.333L8 8 6.667 5.333H5.333L6.667 8l-1.334 2.667h1.334L8 8l1.333 2.667h1.334L9.333 8l1.334-2.667Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M14.53 8.514a1.056 1.056 0 0 0 0-1.041l-2.824-4.959a1.077 1.077 0 0 0-.89-.514H5.17c-.366 0-.72.211-.89.514L1.47 7.473a1.057 1.057 0 0 0 0 1.041l2.81 4.959c.184.316.537.527.89.527h5.634c.366 0 .719-.211.889-.527l2.836-4.959Zm-9.18-5.18h5.288l2.653 4.659-2.674 4.674h-5.26l-2.65-4.674 2.642-4.66Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </Icon>
));

export default Xamarin;
